module.exports = __webpack_public_path__ + "static/media/creating-app.73623a73.svg";